import React from 'react';
import './Skeleton.css';

export const Skeleton = ({ w, h, r = 8, className = '', style = {} }) => (
  <span
    className={`skel ${className}`}
    style={{ width: w, height: h, borderRadius: r, ...style }}
    aria-hidden
  />
);

export const ProductCardSkeleton = () => (
  <div className="skel-card" aria-busy="true">
    <div className="skel skel-card__media" />
    <div className="skel-card__body">
      <span className="skel skel-card__line skel-card__line--xs" />
      <span className="skel skel-card__line skel-card__line--lg" />
      <span className="skel skel-card__line skel-card__line--sm" />
      <div className="skel-card__foot">
        <span className="skel skel-card__line skel-card__line--md" />
        <span className="skel" style={{ width: 30, height: 30, borderRadius: 8 }} />
      </div>
    </div>
  </div>
);

export const ProductGridSkeleton = ({ count = 4 }) => (
  <div className="skel-grid">
    {Array.from({ length: count }).map((_, i) => (
      <ProductCardSkeleton key={i} />
    ))}
  </div>
);

export const RouteSkeleton = () => (
  <div className="skel-route" aria-busy="true" aria-live="polite">
    <div className="container">
      <span className="skel" style={{ width: 120, height: 28, borderRadius: 14, marginBottom: 16 }} />
      <span className="skel" style={{ width: '70%', height: 40, marginBottom: 8 }} />
      <span className="skel" style={{ width: '50%', height: 18 }} />
      <div style={{ height: 32 }} />
      <ProductGridSkeleton count={8} />
    </div>
  </div>
);

export default Skeleton;
